import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _assertThisInitialized from "@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import { createElement } from "@wordpress/element";

/** @format */

/**
 * External dependencies
 */
import 'core-js/fn/object/assign';
import 'core-js/fn/array/from';
import { __, sprintf } from '@wordpress/i18n';
import { Component } from '@wordpress/element';
import { Dropdown, DatePicker as WpDatePicker } from '@wordpress/components';
import { partial } from 'lodash';
import { TAB } from '@wordpress/keycodes';
import moment from 'moment';
/**
 * WooCommerce dependencies
 */

import { dateValidationMessages, toMoment } from '@woocommerce/date';
/**
 * Internal dependencies
 */

import DateInput from './input';
import { H, Section } from '../section';
import PropTypes from 'prop-types';

var DatePicker =
/*#__PURE__*/
function (_Component) {
  _inherits(DatePicker, _Component);

  function DatePicker(props) {
    var _this;

    _classCallCheck(this, DatePicker);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(DatePicker).call(this, props));
    _this.onDateChange = _this.onDateChange.bind(_assertThisInitialized(_this));
    _this.onInputChange = _this.onInputChange.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(DatePicker, [{
    key: "handleKeyDown",
    value: function handleKeyDown(isOpen, onToggle, _ref) {
      var keyCode = _ref.keyCode;

      if (TAB === keyCode && isOpen) {
        onToggle();
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(isOpen, onToggle) {
      if (!isOpen) {
        onToggle();
      }
    }
  }, {
    key: "onDateChange",
    value: function onDateChange(onToggle, dateString) {
      var _this$props = this.props,
          onUpdate = _this$props.onUpdate,
          dateFormat = _this$props.dateFormat;
      var date = moment(dateString);
      onUpdate({
        date: date,
        text: dateString ? date.format(dateFormat) : '',
        error: null
      });
      onToggle();
    }
  }, {
    key: "onInputChange",
    value: function onInputChange(event) {
      var value = event.target.value;
      var dateFormat = this.props.dateFormat;
      var date = toMoment(dateFormat, value);
      var error = date ? null : dateValidationMessages.invalid;
      this.props.onUpdate({
        date: date,
        text: value,
        error: value.length > 0 ? error : null
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          date = _this$props2.date,
          disabled = _this$props2.disabled,
          text = _this$props2.text,
          dateFormat = _this$props2.dateFormat,
          error = _this$props2.error,
          isInvalidDate = _this$props2.isInvalidDate;
      return createElement(Dropdown, {
        position: "bottom center",
        focusOnMount: false,
        renderToggle: function renderToggle(_ref2) {
          var isOpen = _ref2.isOpen,
              onToggle = _ref2.onToggle;
          return createElement(DateInput, {
            disabled: disabled,
            value: text,
            onChange: _this2.onInputChange,
            dateFormat: dateFormat,
            label: __('Choose a date', 'woocommerce-admin'),
            error: error,
            describedBy: sprintf(__('Date input describing a selected date in format %s', 'woocommerce-admin'), dateFormat),
            onFocus: partial(_this2.handleFocus, isOpen, onToggle),
            "aria-expanded": isOpen,
            focusOnMount: false,
            onKeyDown: partial(_this2.handleKeyDown, isOpen, onToggle),
            errorPosition: "top center"
          });
        },
        renderContent: function renderContent(_ref3) {
          var onToggle = _ref3.onToggle;
          return createElement(Section, {
            component: false
          }, createElement(H, {
            className: "woocommerce-calendar__date-picker-title"
          }, __('select a date', 'woocommerce-admin')), createElement("div", {
            className: "woocommerce-calendar__react-dates is-core-datepicker"
          }, createElement(WpDatePicker, {
            currentDate: date,
            onChange: partial(_this2.onDateChange, onToggle),
            isInvalidDate: isInvalidDate
          })));
        }
      });
    }
  }]);

  return DatePicker;
}(Component);

DatePicker.propTypes = {
  /**
   * A moment date object representing the selected date. `null` for no selection.
   */
  date: PropTypes.object,

  /**
   * Whether the input is disabled.
   */
  disabled: PropTypes.bool,

  /**
   * The date in human-readable format. Displayed in the text input.
   */
  text: PropTypes.string,

  /**
   * A string error message, shown to the user.
   */
  error: PropTypes.string,

  /**
   * A function called upon selection of a date or input change.
   */
  onUpdate: PropTypes.func.isRequired,

  /**
   * The date format in moment.js-style tokens.
   */
  dateFormat: PropTypes.string.isRequired,

  /**
   * A function to determine if a day on the calendar is not valid
   */
  isInvalidDate: PropTypes.func
};
export default DatePicker;
//# sourceMappingURL=date-picker.js.map